import React, { useEffect, useState } from "react";
import { api, resolveImg } from "../../lib/api";
import { PageHead, Modal, Field, inp } from "../../components/admin/AdminBits";
import { Plus, Pencil, Trash2, FolderTree } from "lucide-react";
import { toast } from "sonner";

const EMPTY = { name: "", image: "", order: 99 };

export default function AdminCategories() {
  const [cats, setCats] = useState([]);
  const [edit, setEdit] = useState(null);

  const load = () => api.get("/admin/categories").then(({ data }) => setCats(data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      if (edit.id) await api.put(`/admin/categories/${edit.id}`, edit);
      else await api.post("/admin/categories", edit);
      toast.success("Запазено"); setEdit(null); load();
    } catch { toast.error("Грешка"); }
  };
  const del = async (id) => { if (window.confirm("Изтриване?")) { await api.delete(`/admin/categories/${id}`); load(); } };

  return (
    <div data-testid="admin-categories">
      <PageHead title="Категории" desc="Добавяйте и управлявайте категориите на магазина."
        action={<button onClick={() => setEdit({ ...EMPTY })} className="btn-gold px-4 py-2.5 rounded-sm text-sm flex items-center gap-2" data-testid="add-category-btn"><Plus size={16} /> Нова категория</button>} />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {cats.map((c) => (
          <div key={c.id} className="bg-white border border-stone overflow-hidden" data-testid={`cat-${c.slug}`}>
            <div className="h-28 bg-stone overflow-hidden">{c.image && <img src={resolveImg(c.image)} alt="" className="w-full h-full object-cover" />}</div>
            <div className="p-4 flex items-center justify-between">
              <div className="flex items-center gap-2"><FolderTree size={16} className="text-gold" /><span className="font-serif text-lg text-navy">{c.name}</span></div>
              <div className="flex items-center gap-2">
                <span className="text-xs text-charcoal/50">{c.count || 0}</span>
                <button onClick={() => setEdit(c)} className="text-navy hover:text-gold" data-testid={`edit-cat-${c.slug}`}><Pencil size={15} /></button>
                <button onClick={() => del(c.id)} className="text-charcoal/40 hover:text-red-500"><Trash2 size={15} /></button>
              </div>
            </div>
          </div>
        ))}
      </div>
      {edit && (
        <Modal title={edit.id ? "Редакция" : "Нова категория"} onClose={() => setEdit(null)}>
          <form onSubmit={save}>
            <Field label="Име"><input required value={edit.name} onChange={(e) => setEdit({ ...edit, name: e.target.value })} className={inp} data-testid="cat-name" /></Field>
            <Field label="Изображение (URL)"><input value={edit.image} onChange={(e) => setEdit({ ...edit, image: e.target.value })} className={inp} placeholder="https://..." /></Field>
            <Field label="Подредба"><input type="number" value={edit.order} onChange={(e) => setEdit({ ...edit, order: parseInt(e.target.value) || 0 })} className={inp} /></Field>
            <button type="submit" className="btn-gold w-full py-2.5 rounded-sm mt-2" data-testid="save-cat-btn">Запази</button>
          </form>
        </Modal>
      )}
    </div>
  );
}
